import { v4 as uuidv4 } from "uuid";
export class ClientGridViewModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.webSite = "";
        this.linkedIn = "";
        this.isActive = false;
        this.primaryContacts = [];
        this.primaryLeaveApprovers = [];
        this.secondaryLeaveApprovers = [];
        this.appraisalReviewers = [];
    }
}
export default class ClientGridView extends ClientGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
